import { useCallback } from 'react';
import gsap from 'gsap';

export const useProjectNavigation = () => {
  const turnOnProject = useCallback((scrollRef) => {
    if (scrollRef?.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth" });
    }
    const t1 = gsap.timeline();
    t1.to(
      ".home",
      {
        opacity: 0,
        duration: 1,
      },
      1
    );
    t1.to(
      ".circle1",
      {
        left: "-10%",
        top: "10%",
        duration: 1,
        delay: 1,
        ease: "power1.inOut",
      },
      1
    );
    t1.to(
      ".circle2",
      {
        left: "60%",
        top: "50%",
        duration: 1,
        delay: 1,
        ease: "power1.inOut",
        onComplete: function () {
          gsap.set(".projectWrapper", { opacity: 0 });
          gsap.delayedCall(0.6, function () {
            gsap.set(".mainhome", { display: "none", opacity: 0 });
          });
        },
      },
      1
    );
    t1.to(
      ".home",
      {
        opacity: 1,
        duration: 1,
        delay: 2,
      },
      1
    );
    t1.to(
      ".projectWrapper",
      {
        opacity: 1,
        duration: 1,
        delay: 2.5,
      },
      1
    );
  }, []);

  const turnOffProject = useCallback((scrollRef) => {
    if (scrollRef?.current) {
      scrollRef.current.scrollIntoView({ behavior: "smooth" });
    }
    const t1 = gsap.timeline();
    t1.to(
      ".home",
      {
        opacity: 0,
        duration: 1,
      },
      1
    );
    t1.to(
      ".circle1",
      {
        left: "0%",
        top: "50%",
        duration: 1,
        delay: 1,
        ease: "power1.inOut",
      },
      1
    );
    t1.to(
      ".circle2",
      {
        left: "80%",
        top: "2%",
        duration: 1,
        delay: 1,
        ease: "power1.inOut",
        onComplete: function () {
          gsap.set(".projectWrapper", { opacity: 0 });
          gsap.delayedCall(0.6, function () {
            gsap.set(".mainhome", { display: "block", opacity: 0 });
          });
        },
      },
      1
    );
    t1.to(
      ".home",
      {
        opacity: 1,
        duration: 1,
        delay: 2,
      },
      1
    );
    t1.to(
      ".mainhome",
      {
        opacity: 1,
        duration: 1,
        delay: 2.5,
      },
      1
    );
  }, []);

  return { turnOnProject, turnOffProject };
};
